import { withUrl, patch } from '../rest';


export interface ConveyorConfirmReject {
    registerUid: string;
    supplyUids: string[];
    confirm: boolean;
    reasonUid?: string;
    comment?: string;
}

const conveyorCessionsPart = withUrl('conveyor/cessions');

export const conveyorCessions = {
    confirm: patch<ConveyorConfirmReject, void>(
        ({ registerUid, supplyUids, reasonUid, confirm, comment = '' }) => conveyorCessionsPart({
            query: {
                registerUid,
            },
            body: {
                Confirm: confirm,
                ReasonUid: reasonUid,
                Comment: comment,
                Uids: supplyUids,
            },
        }),
    ),
};
